import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";



const OurProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get("http://127.0.0.1:8000/api/products/")
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Product fetch error:", err));
  }, []);

  return (
    <section className="bg-gradient-to-b from-white to-indigo-50 py-16 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        {/* 🛍️ Header */}
<div className="relative mb-10 text-center">
  {/* Centered Heading */}
  <h2 className="text-4xl font-extrabold text-gray-900 flex justify-center items-center gap-2">
    <span role="img" aria-label="bag">🛍️</span> Our Products
  </h2>
  <p className="text-gray-600 text-lg mt-2">
    Explore our best-selling products with amazing cashback deals
  </p>
  <div className="mx-auto w-24 h-1 bg-indigo-500 mt-4"></div>

  {/* 🔹 View All Link — top-right corner */}
  <Link
    to="/all-products"
    className="absolute top-0 right-0 text-indigo-600 font-semibold hover:underline"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  >
    View All →
  </Link>
</div>


        {/* 🔥 Swiper Slider */}
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          spaceBetween={20}
          slidesPerView={1.3}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
            1280: { slidesPerView: 5 },
          }}
          className="py-4"
        >
          {products.length > 0 ? (
  products.map((p) => (
    <SwiperSlide key={p.id}>
      <div className="bg-white border border-gray-100 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden">
        
        {/* 🖼️ Clickable image */}
        <Link to={`/product/${p.id}`}>
          <img
            src={p.image}
            alt={p.title}
            className="w-full h-56 object-cover hover:opacity-90 transition"
          />
        </Link>

        <div className="p-5 text-center">
          {/* 🔗 Clickable product title */}
          <Link
            to={`/product/${p.id}`}
            className="block text-lg font-semibold text-gray-800 mb-1 truncate hover:text-indigo-600"
          >
            {p.title}
          </Link>

          <p className="text-gray-500 text-sm line-clamp-2 mb-3">
            {p.description}
          </p>
          <div className="flex justify-center items-center gap-3">
            <span className="text-indigo-600 font-bold">
              ₹{p.price}
            </span>

            <Link
              to={`/product/${p.id}`}
              className="bg-indigo-600 text-white px-4 py-1 rounded-full text-sm hover:bg-indigo-700 transition"
            >
              View
            </Link>
          </div>
        </div>
      </div>
    </SwiperSlide>
  ))
) : (
  <p className="text-gray-500 text-center col-span-full py-10">
    No products available yet.
  </p>
)}

        </Swiper>
      </div>
    </section>
  );
};

export default OurProducts;
